module.exports = __webpack_public_path__ + "static/media/ic_monthly_plan.507bfd03.svg";